import apiClient from '@/lib/api/apiClient'
import { API_ENDPOINTS } from '@/lib/api/config'
import type { SecurityNotificationConfig } from './types'

export type { SecurityNotificationConfig } from './types'

/**
 * Angular `GET /api/config/notification_content` — security toast config.
 */
export async function fetchSecurityNotificationContent(): Promise<SecurityNotificationConfig> {
  const res = await apiClient.get<SecurityNotificationConfig>(
    API_ENDPOINTS.SECURITY_NOTIFICATION_CONTENT,
  )
  return res.data ?? {}
}
